/** Returns true when JWT `exp` is in the past (60s skew). */
export function isAccessTokenExpired(token: string): boolean {
  try {
    const parts = token.split('.')
    if (parts.length < 2) return true
    const payload = JSON.parse(atob(parts[1] ?? '')) as { exp?: number }
    if (typeof payload.exp !== 'number') return false
    const skewMs = 60_000
    return Date.now() >= payload.exp * 1000 - skewMs
  } catch {
    return true
  }
}
